module.exports = __webpack_public_path__ + "img/visual_no_image.68de623c.png";